import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useLocation, useMatch } from 'react-router';
import ExosLogo from '../../../assets/images/Exos-logomark.svg';
import { useGoBack } from '../../../hooks/useGoBack';
import { TrackingEventData } from '../../../hooks/useTracking';
import { EventNames } from '../../../utils/trackingEvents';
import Button, { ButtonIconPosition, ButtonVariant } from '../Button';
import Text, { TextColor, TextKind } from '../Text';

interface Props {
  eventData?: TrackingEventData;
}

const BackButton: React.FC<Props> = ({ eventData }) => {
  const location = useLocation();
  const { goBack } = useGoBack();
  const isMemberProfile = useMatch('/app/members/:memberId');
  const gameplanRegex =
    /\/app\/members\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\/gameplan/;
  const trainingPlanRegex =
    /\/app\/members\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\/trainingPlan\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\/?/;
  const isGameplanPage = gameplanRegex.test(location.pathname);
  const isTrainingPlanPage = trainingPlanRegex.test(location.pathname);

  const handleBackClick = () => {
    goBack();
  };

  const shouldShowBackButton =
    isMemberProfile || isGameplanPage || isTrainingPlanPage;

  if (shouldShowBackButton) {
    return (
      <Button
        variant={ButtonVariant.Dark}
        onClick={handleBackClick}
        testId="back-button"
        trackingData={{ eventName: EventNames.BackButtonClick, ...eventData }}
        icon={<FontAwesomeIcon color={TextColor.Contrast} icon={faArrowLeft} />}
        iconPosition={ButtonIconPosition.Left}
      >
        <Text color={TextColor.Contrast} kind={TextKind.BodyM}>
          Back
        </Text>
      </Button>
    );
  }

  return <img src={ExosLogo} alt="Exos Logo" width={30} height={30} />;
};

export default BackButton;
